import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MainPageComponent } from './main-page.component';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MainPageSaveGuard implements CanDeactivate<MainPageComponent> {
    constructor() {

    }

    canDeactivate(component: MainPageComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
               return true;
        }
}
